import React from "react";

export class PinRangeField extends React.Component {
  /*
    This is a custom property for the react json schema form.
  */
  constructor(props){
    super(props);
    this.state = {
      min:'',
      max:'',
    };
  }

  onChange(name){
    return (event) => {
      this.setState({
        [name]: parseInt(event.target.value),
      }, () => this.props.onChange(this.state));

    };
  }

  render() {
    var min = this.state.min;
    var max = this.state.max;

    return (
      <div className="row">
        <div className="col-sm-3">
          <label>Min</label>
          <input type="integer" className="form-control " value={min || ''} onChange={this.onChange("min")} />
        </div>
        <div className="col-sm-3">
          <label>Max</label>
          <input type="integer" className="form-control" value={max || ''} onChange={this.onChange("max")} />
        </div>
        <div><p></p>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/views/elements/CustomFields.js